import React from "react";
import { connect } from "react-redux";
import helperNumbers from "../../../helpers/numbers";
import { Tooltip, Popover, OverlayTrigger } from "react-bootstrap";
import constantsReportCampaign from "./constants/reportCampaign";
import statusCampaign from "./constants/status-campaign";

const CardReport = ({
  which_type_select,
  status_campaign,
  count_active_campaign,
  count_active_advertise,
  count_click,
  count_view,
  time_view_campaign,
  price,
}) => {
  let activeItemString = "";
  let activeItemValue = "";
  switch (which_type_select) {
    case constantsReportCampaign.whichTypeSelect.CAMPAIGN:
      activeItemString = "وضعیت کمپین";
      activeItemValue = status_campaign;
      break;
    case constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS:
      activeItemString = "کمپین فعال";
      activeItemValue = count_active_campaign;
      break;
  }

  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0">
      <div className="container-fluid container-card-report py-0 py-lg-4">
        <div className="row">
          {!activeItemString == true ? (
            <></>
          ) : (
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 py-2 py-md-0 container-card-report-item">
              <div className="d-flex ">
                <div className="card-value-unit bg-success py-2 px-4">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(activeItemValue)}
                  </div>
                  <div className="card-unit text-dark"></div>
                </div>
                <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                  {activeItemString}
                </div>
              </div>
            </div>
          )}

          <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(
                          count_view
                        )
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(count_view + "")
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {helperNumbers.getUnitNumber(count_view + "")}
                  </div>
                </div>
              </OverlayTrigger>

              <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                تعداد نمایش
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(
                          time_view_campaign
                        )
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(
                        time_view_campaign + ""
                      )
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {helperNumbers.getUnitNumber(time_view_campaign + "")}
                  </div>
                </div>
              </OverlayTrigger>
              <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                {/* کلیک */}
                زمان نمایش (دقیقه)
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 py-2 py-md-0 container-card-report-item">
            <div className="d-flex ">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => (
                  <Tooltip id="tooltip-report-card" {...props}>
                    <span>
                      {helperNumbers.toPersianNum(
                        helperNumbers.addCommaToSeparateGroupThreeNumber(price)
                      )}
                    </span>
                  </Tooltip>
                )}
              >
                <div className="card-value-unit bg-success py-2 px-4 ">
                  <div className="card-value text-center text-dark">
                    {helperNumbers.toPersianNum(
                      helperNumbers.getSummaryNumberForPresent(price + "")
                    )}
                  </div>
                  <div className="card-unit text-dark">
                    {" "}
                    {helperNumbers.getUnitNumber(price + "")}
                  </div>
                </div>
              </OverlayTrigger>
              <div className="d-flex align-items-center card-title w-100 justify-content-center text-dark">
                هزینه(تومان)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    which_type_select: state.reportCampaign.which_type_select,
    count_active_campaign: state.reportCampaign.count_active_campaign,
    status_campaign: state.reportCampaign.status_campaign,
    count_active_advertise: state.reportCampaign.count_active_advertise,
    count_click: state.reportCampaign.count_click,
    count_view: state.reportCampaign.count_view,
    time_view_campaign: state.reportCampaign.time_view_campaign,
    price: state.reportCampaign.price,
    date_from: state.reportCampaign.date_from,
    date_to: state.reportCampaign.date_to,
  };
};
export default connect(mapStateToProps, null)(CardReport);
